import { ComponentType } from 'react';

import { OrderAheadConfigurationNavbarIcon } from '@ocx/graphql';
import { TabBarOrderAheadDeliveryIcon, TabBarOrderAheadFoodIcon, TabBarOrderAheadMerchIcon } from '@ocx/ui-icons';

export const orderAheadTabIconMap: Record<OrderAheadConfigurationNavbarIcon, ComponentType> = {
  [OrderAheadConfigurationNavbarIcon.Food]: TabBarOrderAheadFoodIcon,
  [OrderAheadConfigurationNavbarIcon.Delivery]: TabBarOrderAheadDeliveryIcon,
  [OrderAheadConfigurationNavbarIcon.Merch]: TabBarOrderAheadMerchIcon,
};
